module.exports = __webpack_public_path__ + "static/img/winter_banner.afa2d7a4.jpg";